export const MAX_ALLOWED_OPENED_PETIENTS = 10;